var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    {
      attrs: {
        title: _vm.$t("contacts.imprt_cntcts"),
        iconF7: "list_bullet",
        returnUrl: "/contacts/",
      },
    },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-row",
            { staticClass: "m-0 pb-3" },
            [
              _c(
                "b-col",
                { attrs: { cols: "2" } },
                [_c("back-button", { attrs: { returnUrl: _vm.returnUrl } })],
                1
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            { staticClass: "form-group justify-content-md-end" },
            [
              _c(
                "b-col",
                {
                  staticClass: "mr-md-5 mr-lg-5 mr-xl-0",
                  attrs: { cols: "5", sm: "4", md: "2" },
                },
                [
                  _c(
                    "label",
                    {
                      staticClass:
                        "fileContainer attachmentImportButtonLength fs-13px w-150px",
                    },
                    [
                      _vm._v("\n          Choose file\n          "),
                      _c("input", {
                        ref: "fileInput",
                        attrs: { type: "file", name: "file2", id: "file2" },
                        on: { change: _vm.onFileChange },
                      }),
                    ]
                  ),
                ]
              ),
              _vm._v(" "),
              _c(
                "b-col",
                {
                  staticClass: "ml-md-5 ml-lg-0",
                  attrs: { cols: "7", sm: "8", md: "5" },
                },
                [
                  _c("input", {
                    directives: [
                      {
                        name: "model",
                        rawName: "v-model",
                        value: _vm.attachmentName,
                        expression: "attachmentName",
                      },
                    ],
                    staticClass: "form-control",
                    attrs: {
                      name: "filename",
                      placeholder: "Choose file",
                      type: "text",
                      disabled: "",
                    },
                    domProps: { value: _vm.attachmentName },
                    on: {
                      input: function ($event) {
                        if ($event.target.composing) {
                          return
                        }
                        _vm.attachmentName = $event.target.value
                      },
                    },
                  }),
                ]
              ),
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "b-row",
            [
              _c(
                "b-col",
                {
                  attrs: {
                    md: "3",
                    lg: "2",
                    "offset-md": "9",
                    "offset-lg": "10",
                  },
                },
                [
                  _c(
                    "b-button",
                    {
                      attrs: { variant: "primary", size: "lg" },
                      on: { click: _vm.importAttachment },
                    },
                    [
                      _c("f7-icon", {
                        attrs: { f7: "list_bullet", size: "17px" },
                      }),
                      _vm._v(" "),
                      _c("span", [_vm._v(_vm._s(_vm.$t("common.imprt")))]),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }